/**
 * A labelled checkbox with an optional line of explanation underneath.
 *
 * Lifted out of MySettings when the notification switches needed the same
 * thing, rather than copied -- there were already three near-identical local
 * Toggles in this codebase and a fourth would have settled the question the
 * wrong way.
 */
export function Toggle({
  label,
  hint,
  checked,
  onChange,
}: {
  label: string;
  hint?: string;
  checked: boolean;
  onChange: (value: boolean) => void;
}) {
  return (
    <label className="flex items-start gap-2">
      <input
        type="checkbox"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        className="mt-0.5 accent-brand-600"
      />
      <span className="min-w-0">
        <span className="block text-sm text-content">{label}</span>
        {hint ? <span className="block text-xs text-faint">{hint}</span> : null}
      </span>
    </label>
  );
}
